import { Box, Paper, Stack, Typography, Chip } from '@mui/material';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';

/**
 * Forward-looking placeholder for tabs that land in a later phase (Technical
 * Health → Phase 2, Gaps → Phase 4). Keeps the five-tab shell complete while
 * the data layers are built.
 */
export default function PlaceholderTab({ title, message, phase }) {
  return (
    <Box>
      <Paper variant="outlined" sx={{ p: 6, borderRadius: 2, textAlign: 'center' }}>
        <Stack spacing={1.5} alignItems="center">
          <ConstructionRoundedIcon sx={{ fontSize: 48, opacity: 0.5 }} color="action" />
          <Typography variant="h6">{title}</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 460 }}>
            {message}
          </Typography>
          {phase && <Chip size="small" variant="outlined" label={phase} />}
        </Stack>
      </Paper>
    </Box>
  );
}
